import {
  createActionDispatcher,
  type ActionDispatcherDeps,
} from './createActionDispatcher';
import type { ActionDispatcher } from '@de/utils/action-resolver/ActionDispatcher';

/**
 * @deprecated Use {@link createActionDispatcher} from
 * `@de/utils/configurable-step` instead. Replaced by the production
 * registry-backed factory in DB-2.1 (EDUN-10689). This shim is kept
 * for one cycle so DB-2.2 can delete it in the same PR that ships
 * the real ComparisonProvider hookup; do not write new callers.
 *
 * The legacy `NavigationDispatcherDeps` shape is preserved so callers
 * that wired the S8-minimum factory keep working without source edits
 * -- the new factory accepts the same `advanceStep` /
 * `goToStep` / `goBack` / `clearFormState` deps under
 * {@link ActionDispatcherDeps}.
 */
export interface NavigationDispatcherDeps {
  advanceStep: () => void | Promise<void>;
  goToStep?: (stepId: string, opts?: { resetFlowState?: boolean }) => void;
  goBack?: () => void;
  clearFormState?: (keys: readonly string[]) => void;
}

let warned = false;

/**
 * @deprecated Use {@link createActionDispatcher}. See module-level
 * JSDoc for the migration path and removal timeline.
 */
export function createNavigationActionDispatcher(
  deps: NavigationDispatcherDeps,
): ActionDispatcher {
  if (!warned) {
    warned = true;
    // eslint-disable-next-line no-console
    console.warn(
      '[deprecated] createNavigationActionDispatcher → createActionDispatcher (DB-2.1, EDUN-10689). This shim will be removed in DB-2.2.',
    );
  }
  return createActionDispatcher(deps as ActionDispatcherDeps);
}
